import { AsyncLocalStorage } from "async_hooks";

import { type StorageData } from "./contextStorage";

const serverContextStorage = new AsyncLocalStorage<StorageData>();

export default serverContextStorage;
